import PropTypes from 'prop-types';
import React from 'react';

import CheckboxV2 from '@/components/common/CheckboxV2';
import SendEmailCheckbox from '@/components/checkout/common/Summary/SendEmailCheckbox';

import styles from './SummaryCheck.module.scss';

export const SummaryCheck = (
  { id, className, label, checked, onCheckedChange, actAsCustomer = false, disabled = false, required = false }
) => (
  <div className={`${styles.container} ${className || ''}${checked ? ' checked' : ''} tu-summary-check`} data-test-id="summary-check">
    {actAsCustomer && (
      <SendEmailCheckbox />
    )}
    <CheckboxV2
      id={id}
      label={label}
      checked={checked}
      required={required}
      onChange={() => onCheckedChange(!checked)}
      disabled={disabled}
      rbf="checkbox-CGV"
    />
  </div>
);

SummaryCheck.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onCheckedChange: PropTypes.func.isRequired,
};

export default React.memo(SummaryCheck);
